/*
 * Copyright (c) 2024, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import createLogger from '@salesforce/pwa-kit-runtime/utils/logger-factory'

const logger = Object.freeze(createLogger({packageName: 'retail-react-app'}))
export default logger
